export enum FeedbackState {
	start = 'start',
	viewed = 'viewed',
	agreed = 'agreed',
	sent = 'sent',
	confirmed = 'confirmed',
	sayDo = 'sayDo',
}
